<div class="content-body padding-top-20 padding-bottom-20">
    <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
            <label>Select Screening Center</label>
            <ng-select #filterScreeningCenter name="screeingcenters" placeholder="Select screening center"
                bindLabel="itemName" bindValue="id" [items]="screeningCenters" [clearable]="true" [searchable]="true"
                [(ngModel)]="rescheduledScreeningCenter" (change)="getAvailableDates()">
            </ng-select>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
            <label>Date</label>
            <input type="text" placeholder="Choose Date..." class="form-control" onkeydown="return false"
                [bsConfig]="datePickerConfig" (bsValueChange)="onDateChange($event)" [(ngModel)]="selectedDate"
                bsDatepicker />
        </div>
    </div>

    <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-12 col-lg-12">
            <div class="form-group" style="margin-top: 20px;">
                <div *ngIf="showOperatorLable" style="float: left;font-weight:normal">Select Operator
                    <span class="mandatory-field" style="color: red;">*&nbsp;</span>:&nbsp;
                </div>

                <div class="btn-group shadow-0" role="group" *ngIf="showOperatorLable"
                    style="text-align: initial; margin-top: 2%; width: 100%; display: inline-block;">
                    <button class="btn btn-sm btn-light active-button operator-btn venue-tooltip"
                        *ngFor="let list of operatorList; let i = index" [attr.data-index]="i" type="button"
                        [ngClass]="{active: isSelectedOperator(list, i), 'show-tooltip': showTooltip }"
                        data-mdb-color="dark" id="{{list.fullName}}" name="{{list.fullName}}" value="{{list.fullName}}"
                        (click)="onSelectoperator(list.fullName, i, list.userId)" style="overflow: visible;">
                        <span style="font-weight: bold;">Screening Station-{{i+1}}</span>
                        <span class="tooltiptext" [ngClass]="{ 'show': showTooltip, 'hide': showTooltip}">
                            Venue: {{(list.businessAddress == null || list.businessAddress == "") ? list.orgVenue :
                            list.businessAddress}}</span>
                        <div style="font-size: 12px; border-bottom: 1px solid gray;">
                            <div *ngIf="list.availableSlotCount > 1" style="color: green;">
                                {{list.availableSlotCount}} Slots Available</div>
                            <div *ngIf="list.availableSlotCount == 1" style="color: green;">{{list.availableSlotCount}}
                                Slot Available</div>
                            <div *ngIf="list.availableSlotCount < 1" style="color: red;">Slots Full</div>
                        </div>
                        <div class="venue-details" style="font-size: 11px;">
                            <!-- <i class="fa fa-info-circle" aria-hidden="true" style="color:steelblue;"></i> -->
                            {{(list.businessAddress == null || list.businessAddress == "") ? list.orgVenue :
                            list.businessAddress}}
                        </div>
                    </button>

                </div>

                <p *ngIf="!isOperatorAvailable" style="font-size: 13px;">
                    No slots are available on the selected date, please select another date to continue...
                </p>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-12 col-lg-12">
            <div class=" form-group" style="margin-bottom: 10px;">
                <div *ngIf="showSlotTimeLable" style="float: left;font-weight:normal">Time
                    <span class="mandatory-field" style="color: red;">*&nbsp;</span>:&nbsp;
                </div>
                <div class="btn-group shadow-0" role="group" *ngIf="showSlotTimeLable"
                    style="margin-top: 1%; width: 100%; display: block; float: left;">
                    <button *ngFor="let list of avilableTimings; let i = index" [attr.data-index]="i" type="button"
                        class="btn btn-sm btn-light slots-button slot-active-button slot-price-tooltip"
                        [ngClass]="{active: isSelectedItem(list, i)}" data-mdb-color="dark" id="{{list.slotHours}}"
                        name="{{list.slotHours}}" value="{{list.slotHours}}"
                        [ngStyle]="{'color': !list.isActive ? 'red' : 'green'}"
                        (click)="onSelectSlot(list.slotHours, i)"
                        [disabled]="!list.isActive">{{tConvert(list.slotHours)}}
                    </button>
                    <p *ngIf="!isSlotTimeAvailable" style="font-size: 13px;">No slots are available for the
                        selected screening station, please
                        select
                        another date or screening station to continue...</p>

                </div>
            </div>
        </div>
    </div>

    <div class="row" style="margin-top: 15px;">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="col-xs-12 text-center mTop15">
                <button style="margin-right: 5px;" type="submit" class="btn
                        btn-sm btn-success marginLR5" [disabled]="disableSubmitButton"
                    (click)="onConfirmReschedule(rescheduleConfirmationContent)">
                    <i class="fa fa-fw fa-lg fa-check-circle"></i>
                    Reschedule</button>
                <!-- <button (click)="onCancelClick()" style="margin-left: 5px;" class="btn btn-sm btn-danger marginLR5">
                    <i class="fa fa-fw fa-lg fa-times-circle"></i>
                    Cancel</button> -->
            </div>
        </div>
    </div>
</div>

<!-- start reschedule confirmation modal -->

<ng-template #rescheduleConfirmationContent let-modal>
    <div class="modal-header">
        <div style="display:flex; justify-content:space-between; width:100%">
            <h4 style="margin: 0px;">
                Reschedule Appointment - MRN: {{selectedAppointment.mrn}}
            </h4>
            <h4 (click)="modalRef.hide()" style="cursor:pointer; margin: 0px;">
                <i class="fa fa-times" aria-hidden="true"></i>
            </h4>
        </div>
    </div>
    <div class="modal-body" style="padding-bottom: 0;">
        <div class="row grid-data">
            <div style="margin-top: 10px; margin-bottom: 20px; font-weight: bold;">Review appointment details before
                confirming,</div>
            <table class="table table-hover table-responsive fixed-header table-striped">

                <tbody>
                    <tr>
                        <td style="width: 40%;">Place of Eye Screening</td>
                        <td>:</td>
                        <td>{{ selectedAppointment.orgName }}</td>
                    </tr>
                    <tr>
                        <td>Date</td>
                        <td>:</td>
                        <td>{{appointmentDetails.date | date: 'dd-MMM-yyyy'}}</td>
                    </tr>
                    <tr>
                        <td>Time</td>
                        <td>:</td>
                        <td>{{tConvert(appointmentDetails.time)}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="modal-footer" style="justify-content: center !important;">
        <div style="display: flex !important;justify-content: center !important;">
            <div>
                <button class="btn btn-sm btn-warning btn-80"
                    style="background-color:#5d9cec; border:1px solid #5d9cec; color:white; border-radius:0px; width:150px;"
                    (click)="modalRef.hide();" id="acceptContinueBtn">Edit</button>
            </div>
            <div>
                <button #closebutton type="button" style="border-radius: 0px;margin-left: 20px; width:150px;"
                    class="btn btn-sm btn-success btn-80"
                    (click)="modalRef.hide();rescheduleAppointment()">Confirm</button>
            </div>
        </div>
    </div>
</ng-template>

<!-- End reschedule confirmation modal -->